import { ref, watch } from 'vue'

const CLIENT_SETTINGS_KEY = 'radsuite_client_settings_v1'

export interface ClientSettings {
  maxLoadedChannels: number
}

const defaultSettings: ClientSettings = {
  maxLoadedChannels: 3
}

function loadSettings(): ClientSettings {
  try {
    const raw = localStorage.getItem(CLIENT_SETTINGS_KEY)
    if (raw) {
      const parsed = JSON.parse(raw)
      return {
        maxLoadedChannels: Math.min(5, Math.max(1, Number(parsed.maxLoadedChannels) || defaultSettings.maxLoadedChannels))
      }
    }
  } catch (e) {
    console.error('Failed to load client settings:', e)
  }
  return { ...defaultSettings }
}

const settings = ref<ClientSettings>(loadSettings())

watch(settings, (newVal) => {
  localStorage.setItem(CLIENT_SETTINGS_KEY, JSON.stringify(newVal))
}, { deep: true })

export function useClientSettings() {
  return {
    settings,
    updateSettings: (partial: Partial<ClientSettings>) => {
      settings.value = { ...settings.value, ...partial }
    }
  }
}
